export const styles = {
  container: "flex w-full flex-col gap-4 border-none p-4",
  headerTop: "grid h-[40px] w-full grid-cols-[1fr_120px] items-center gap-2",
  userText: "text-left text-white",
  notificationContainer: "flex w-full items-end justify-end",
  salesCard: "grid w-full grid-cols-[1fr_110px] items-center border-b-[3px]",
  salesInfo: "bg-primary-darkest flex h-[80px] flex-col justify-center px-4",
  salesLabel: "text-sm font-normal text-white",
  salesValue: "text-2xl font-normal text-white",
  eyeContainer: "flex h-full w-full cursor-pointer items-center justify-center"
} as const

export const colors = {
  headerBackground: '#1E1E1ED9',
  borderOrange: '#FF6A00',
  eyeContainerBackground: '#191818',
  eyeIcon: '#6C6E71'
} as const

export const texts = {
  userGreeting: "Hola, usuario",
  salesLabel: "Tus ventas hoy",
  hiddenBalance: "••••••",
  visibleBalance: "Q 0.00"
} as const


